import { useNavigate } from '@tanstack/react-router'
import { Table, Typography } from 'antd'
import React from 'react'
import { UsePaginationTableProps } from '../../hooks/use-pagination'
import { TimeAgo } from '../../components/time-ago'
import { User } from '../user'
import { RoleTag } from './role-tag'
import { UserLink } from './user-link'
import { BlockedTag } from './blocked-tag'
import { UserAvatar } from './user-avatar'
import { useTranslation } from 'react-i18next'
import { MailLink } from '../../components/mail-link'

export function UserTable({ withColumnDefaults, ...props }: UsePaginationTableProps<User>) {
    const navigate = useNavigate()
    const { t } = useTranslation()

    return (
        <Table
            size="small"
            {...props}
            rowClassName="cursor-pointer"
            scroll={{
                x: 800,
                y: 800,
            }}
            onRow={(record) => {
                return {
                    onClick: () => {
                        navigate({
                            to: '/users/$userId',
                            params: { userId: record.id },
                        })
                    },
                }
            }}
            columns={withColumnDefaults([
                {
                    dataIndex: 'id',
                    width: 60,
                    key: 'id',
                    render(_, record) {
                        return <UserAvatar user={record} />
                    },
                },
                {
                    title: t('Role'),
                    dataIndex: 'role',
                    key: 'role',
                    width: 100,
                    render(role, user) {
                        if (user.blockedAt) {
                            return <BlockedTag />
                        }

                        return <RoleTag role={role} />
                    },
                    sorter: true,
                },
                {
                    title: t('Name'),
                    dataIndex: 'name',
                    key: 'name',
                    sorter: true,
                    render(name, { id }) {
                        return (
                            <UserLink
                                id={id}
                                name={name}
                            />
                        )
                    },
                },
                {
                    title: t('Company'),
                    dataIndex: 'activeCompanyId',
                    key: 'activeCompanyId',
                    sorter: true,
                    render(_, { activeCompany }) {
                        return <Typography.Text ellipsis>{activeCompany?.name}</Typography.Text>
                    },
                },
                {
                    title: t('Email'),
                    dataIndex: 'email',
                    key: 'email',
                    width: 260,
                    render(email) {
                        return <MailLink email={email} />
                    },
                    sorter: true,
                },
                {
                    title: t('Created'),
                    dataIndex: 'createdAt',
                    key: 'createdAt',
                    width: 180,
                    render(date) {
                        return <TimeAgo date={date} />
                    },
                    sorter: true,
                },
            ])}
        />
    )
}
